import { RealityChecks } from './RealityChecks';

export default RealityChecks;
